var exports = {
  "k": "x52a3aa3b--6be3f7--container",
};

module.exports = exports;
